'use strict';

Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.default = InspiringMessages;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _InspiringMessage = require('./InspiringMessage.jsx');

var _InspiringMessage2 = _interopRequireDefault(_InspiringMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'inspiring-messages';

function InspiringMessages(_ref) {
		var messages = _ref.messages;

		return _react2.default.createElement(
				'div',
				{ className: CLASS_NAME },
				_react2.default.createElement(
						'div',
						{ className: 'wrapper' },
						messages.map(function (_ref2, key) {
								var title = _ref2.title,
								    content = _ref2.content,
								    icon = _ref2.icon,
								    iconAlt = _ref2.iconAlt,
								    link = _ref2.link;
								return _react2.default.createElement(_InspiringMessage2.default, {
										title: title,
										content: content,
										icon: icon,
										iconAlt: iconAlt,
										link: link,
										key: key
								});
						})
				)
		);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteFooter/InspiringMessages/InspiringMessages.jsx
// module id = 1127
// module chunks = 0